export { default as LoadingIcon } from './loading';
